<template>
  <task-page class="font-degular max-w-2xl" v-if="isDataLoaded">
    <task-list :log="log" />
  </task-page>
</template>

<script>
import TaskList from '@/components/TaskList'
import TaskPage from '@/components/TaskPage'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'MonthlyTasks',
  components: {
    TaskList,
    TaskPage
  },
  computed: {
    ...mapState('config', ['isDataLoaded']),
    ...mapGetters('storeModule', ['monthlyLog']),
    ...mapGetters('storeModule/logs', ['logById']),
    ...mapGetters('global', ['monthlyTasks']),
    log() {
      return this.monthlyLog ? this.logById(this.monthlyLog) : null
    }
  }
}
</script>
